export * from "./collateProjectVariables";
